export * from "./collateProjectVariables";
